import { useMemo } from "react";
import { useSelector } from "react-redux";

type AnyFunction = (...args: any[]) => any;
export const useMakeSelector = <Fn extends AnyFunction>(makeSelector: Fn, props: Parameters<Fn>): ReturnType<ReturnType<Fn>> => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getSelector: ReturnType<Fn> = useMemo(() => makeSelector(...props), [...props]);
    return useSelector(getSelector);
};
